import CardHeader, { CardHeaderTypeMap } from "@mui/material/CardHeader";
import { BaseProps } from "@mui/material/OverridableComponent";
import { styled } from "@mui/material/styles";
import * as React from "react";

interface IClassProps {
    color: MprcColors;
    dense?: boolean;
}

interface IProps extends IClassProps {
    children?: React.ReactNode;
    center?: boolean;
}

type MprcCardHeaderColorProps = Subtract<BaseProps<CardHeaderTypeMap>, "titleTypographyProps">;

type Props = IProps & MprcCardHeaderColorProps;

const StyledCardHeader = styled
    (CardHeader, { shouldForwardProp: (propName: string) => propName != "color" && propName != "dense" })<IClassProps>(
        ({ dense, color, theme }) => (
            {
                padding: 0,
                '& .MuiCardHeader-content': {
                    padding: theme.spacing(dense ? 1 : 2),
                    background: theme.palette[color].dark,
                    "& a": {
                        color: theme.palette[color].contrastText
                    },
                    "& a:hover": {
                        color: theme.palette[color].light
                    }
                },
                '& .MuiCardHeader-title': {
                    color: theme.palette[color].contrastText
                }
            }
        ));

export const MprcCardHeaderColor: React.FC<Props> = (props) => {
    const {
        center,
        children,
        ...rest
    } = props;

    return (
        <StyledCardHeader
            {...rest}
            titleTypographyProps={{
                align: center ? "center" : "inherit",
                variant: "h3",
                color: "inherit"
            }}
        >
            {children}
        </StyledCardHeader>
    );
};
